import { type NotificationData } from "~/features/notifications/Messages";

export interface NotificationsPageState {
  data: NotificationData[];
  isLoading: boolean;
  isLoaded: boolean;
  error: boolean;
  totalNumberOfResults: number;
  lastFetchTime: number;
  newNotificationAmount: number | undefined;
}

export const notificationsPageInitialState: NotificationsPageState = {
  isLoading: false,
  isLoaded: false,
  error: false,
  data: [],
  totalNumberOfResults: 0,
  lastFetchTime: 0,
  newNotificationAmount: window.SCHA.nNotifications,
};
